export var noop=function(){for(var o=[],n=0;n<arguments.length;n++)o[n]=arguments[n]};